"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const trans_1 = require("@common/tsutils/trans");
let StatsCard = class StatsCard extends vue_property_decorator_1.Vue {
    link_classes(i) {
        const classes = {
            'cluster--inside': true,
        };
        const propName = `cluster--inside-${this.stats_data[i].idx + 1}`;
        //@ts-ignore
        classes[propName] = true;
        return classes;
    }
    get title() {
        return (0, trans_1.trans)(`toolkit.coocurrence.${this.type}`);
    }
    get description() {
        return (0, trans_1.trans)(`toolkit.coocurrence.${this.type}_desc`);
    }
    openModal(cluster) {
        this.$emit('modal', this.type, cluster);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], StatsCard.prototype, "type", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: () => null })
], StatsCard.prototype, "stats_data", void 0);
StatsCard = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {}
    })
], StatsCard);
exports.default = StatsCard;
